module.exports = __webpack_public_path__ + "img/pho.9c00b99f.jpg";